import { axiosPrivate } from "./axios";

export const scienceworkByApi = async (payloadData) => {
  let res = await axiosPrivate.get("/frontend/sciencework", payloadData);
  return res.data;
};
